export const PreQualifierAssetTypeListMessages = {
  title: {
    id: 'Pages.PreQualifierAssetTypeSelection.AssetTypeList.title',
    description: 'Select asset-type list title',
  },
}
